import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const CONSENT_KEY = "sb_cookie_consent";
export const CONSENT_EVENT = "sb-consent";
export const OPEN_CONSENT_EVENT = "sb-open-consent";
export const openConsent = () => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT));
const KEY = CONSENT_KEY;

export const applyConsent = () => {
  if (localStorage.getItem(KEY) === "rejected") (window.adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1;
};

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  const { pathname } = useLocation();
  useEffect(() => {
    const open = () => setChoice(null);
    window.addEventListener(OPEN_CONSENT_EVENT, open);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, open);
  }, []);
  if (choice || pathname.startsWith("/admin")) return null;
  const save = (v) => {
    const was = localStorage.getItem(KEY);
    localStorage.setItem(KEY, v);
    if (was === "accepted" && v === "rejected") return window.location.reload();
    applyConsent();
    setChoice(v);
    window.dispatchEvent(new Event(CONSENT_EVENT));
  };
  return (
    <div className="fixed bottom-4 inset-x-4 z-50 mx-auto max-w-3xl rounded-xl border border-[#26334D] bg-[#121824]/95 backdrop-blur-xl p-5 shadow-2xl fade-up" data-testid="cookie-banner">
      <p className="text-sm text-slate-300">
        Usiamo cookie tecnici per farti accedere e, con il tuo consenso, cookie di Google AdSense e di altri partner pubblicitari per mostrare annunci.
        Se rifiuti vedrai solo annunci Google non personalizzati. <Link to="/privacy" className="text-emerald-400 underline" data-testid="cookie-privacy-link">Privacy e cookie</Link>
      </p>
      <div className="mt-4 flex gap-3 justify-end">
        <button onClick={() => save("rejected")} className="h-10 px-5 rounded-full border border-[#26334D] text-sm text-slate-300 hover:border-slate-500" data-testid="cookie-reject-button">Rifiuta</button>
        <button onClick={() => save("accepted")} className="h-10 px-5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] text-sm font-bold" data-testid="cookie-accept-button">Accetta</button>
      </div>
    </div>
  );
};
